/* eslint-disable react/no-danger */
import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import PanelClaro from 'newComponents/PanelClaro/PanelClaro';
import Typography from 'newComponents/Typography';
import { converter } from 'helpers/converter';
import { actions as listActions } from 'action-creators/device/list';
import { actions as modifyActions } from 'action-creators/device/modify';
import { actions as detachActions } from 'action-creators/device/detach';
import * as responseActions from 'actions/response';
import { selectMetadataKeyByRegion } from 'reducers/selectors/metadata';
import { DeviceList, Logout } from './components';
import constants from './constants';

const Devices = ({
  initialize,
  devices,
  translations,
  modifyDevice,
  detachDevice,
  detachDevices,
  showDevTools,
  showModal,
  removeModal,
}) => {
  useEffect(() => {
    initialize();
  }, []);
  const { enable: logoutEnable } = useSelector(
    selectMetadataKeyByRegion(constants.myDevices.logout.enable),
  );
  const header = (
    <>
      <Typography element="h3" className="boldHeader">
        {converter.convertApa(translations, constants.myDevices.title)}
      </Typography>
      {logoutEnable && <Logout />}
      <Typography
        element="p"
        dangerouslySetInnerHTML={{
          __html: converter.convertApa(
            translations,
            constants.myDevices.subtitle,
          ),
        }}
      />
      <Typography element="p">
        {converter.convertApa(translations, constants.myDevices.important)}
      </Typography>
      <ul>
        <Typography
          element="li"
          dangerouslySetInnerHTML={{
            __html: converter.convertApa(
              translations,
              constants.myDevices.rule1,
            ),
          }}
        />
        <Typography
          element="li"
          dangerouslySetInnerHTML={{
            __html: converter.convertApa(
              translations,
              constants.myDevices.rule2,
            ),
          }}
        />
        <Typography
          element="li"
          dangerouslySetInnerHTML={{
            __html: converter.convertApa(
              translations,
              constants.myDevices.rule3,
            ),
          }}
        />
      </ul>
    </>
  );
  return (
    <PanelClaro sectionName="micuentadevices">
      {header}
      <DeviceList
        devices={devices}
        modifyDevice={modifyDevice}
        detachDevice={detachDevice}
        detachDevices={detachDevices}
        showModal={showModal}
        closeModal={removeModal}
        showDevTools={showDevTools}
      />
    </PanelClaro>
  );
};

Devices.propTypes = {
  initialize: PropTypes.func,
  modifyDevice: PropTypes.func,
  detachDevice: PropTypes.func,
  detachDevices: PropTypes.func,
  showModal: PropTypes.func,
  removeModal: PropTypes.func,
  devices: PropTypes.array,
  showDevTools: PropTypes.bool,
  translations: PropTypes.shape({}),
};

const mapStateToProps = ({ cvDevices, translations }) => ({
  ...cvDevices,
  translations,
});

export default connect(
  mapStateToProps,
  {
    ...listActions,
    ...modifyActions,
    ...detachActions,
    ...responseActions,
  },
)(Devices);
